import { FormikHelpers } from "formik";
import { toast } from "react-toastify";
import { api } from "../../../../../../../Api/Api";
import { AddTestimonialInitialValues } from "./FormikValidation";
import axios from "axios";
import { BaseUrl } from "../../../../../../../Api/BaseUrl";

type AddInitialValues = {
  image: any;
};

export const TestimonialSubmitHandler = async (
  values: AddInitialValues,
  actions: FormikHelpers<AddInitialValues>,
  setIsOpen: Function,
  refetch: Function,
  editMode: boolean,
  id: string | number,
  Image: string
) => {
  // Edit

  if (editMode) {
    try {
      const formData = new FormData();

      formData.append("about_image", values?.image);
      const res = await axios.patch(
        `${BaseUrl}/about-image/${id}`,
        formData,

        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("AUTH_TOKEN")}`,
          },
        }
      );
      if (res) {
        toast.success("Gallery updated");
        setIsOpen(false);
        refetch();
      }
    } catch (error: any) {
      actions?.setSubmitting(false);
      actions.setFieldError("image", error?.response?.data?.errors?.image);
    }
  } else {
    // add
    try {
      const formData = new FormData();

      formData.append("about_image", values?.image);

      const res = await axios.post(`${BaseUrl}/about-image`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("AUTH_TOKEN")}`,
        },
      });
      if (res) {
        toast.success("photo added");
        setIsOpen(false);
        refetch();
      }
    } catch (error: any) {
      actions?.setSubmitting(false);
      actions.setFieldError("image", error?.response?.data?.errors?.image);
      actions.setFieldError("title", error?.response?.data?.errors?.name);
    }
  }
};

// extract gallery
export const extractTestimonialData = (data: any) => {
  const res = data?.data?.map((item: any) => {
    return {
      id: item?.id,
      image: item?.[0]?.images,
    };
  });
  return res;
};

// initializing add Department form - Edit / add
export const addModalInitialValuesHandler = (
  modalEditData: any,
  setAddModalInitialValues: Function,
  setEditMode: Function
  
) => {

  if (modalEditData?.length !== 0) {
    setEditMode(true);
    setAddModalInitialValues({
      id: modalEditData?.[0]?.id,
      title: modalEditData?.[0]?.title,
      image: modalEditData?.[0]?.image,
    });
  } else {
    setEditMode(false);
    setAddModalInitialValues(AddTestimonialInitialValues);
  }
};

// Department table edit onclick trigger
export const onEditClickHandler = (
  selectedId: any,
  setModalEditData: Function,
  setIsOpen: Function,
  testimonialData: any
) => {
  setModalEditData([]);
  setModalEditData(
    testimonialData?.data?.filter((itm: any) => itm?.id === selectedId)
  );

  setIsOpen(true);
};

// add Department open / close
export const modalHandler = (
  setModalEditData: Function,
  setIsOpen: Function
) => {
  setModalEditData([]);
  setIsOpen(true);
};

// Department delete
export const deleteClickHandler = (
  selectedId: string | number,
  refetch: Function
) => {
  api
    .delete(`/about-image/${selectedId}`, {}, true)
    .then(async function ([success, response]: any) {
      refetch();
      toast.success("Deleted");
    })
    .catch((err) => {
      toast.error("Unexpected Error Occurred");
    });
};

export const StatusClickHandler = (
  selectedId: string | number,
  refetch: Function,
  newStatus: number
) => {
  api
    .patch(
      `/about-image/publish/${selectedId}`,
      {
        status: newStatus,
      },
      true
    )
    .then(async function ([success, response]: any) {
      refetch();
      toast.success("Updated");
    })
    .catch((err) => {
      toast.error("Unexpected Error Occurred");
    });
};
export const setCurrentPageaward = (navigate: Function, pageNo: any) => {
  navigate(`/admin/staff/${pageNo}`);
};
